export const ORDERSSORTASCENDING = "ordersSortAscending";
export const ORDERSSORTPROPERTYNAME = "ordersSortPropertyName";
export const ORDERSTATUSFILTER = "orderStatusFilter";
